import React from 'react';

const StatusSelect = ({ status, setStatus }) => {
  const filterOptions = [
    { value: 'all', name: 'Tutti gli stati' },
    { value: 'closed', name: 'Prenotazioni chiuse' },
    { value: 'pending', name: 'Prenotazioni in attesa' }
  ];

  return (
    <select
      value={status || ''}
      onChange={(e) => setStatus(e.target.value)}
      className="form-control"
      style={{
        borderRadius: "25px",
        height: "50px",
        boxShadow: "0px 3px 6px #00000029",
        border: "none",
        fontSize: "0.9em",
        width: "100%",
        padding: "0 15px",
        backgroundColor: "white"
      }}
    >
      {filterOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

export default StatusSelect;